import {DataStatus} from 'platform/components';

import {
  useSmsGetKonzultaCredentialsQuery,
  useSmsPatchKonzultaCredentialsMutation,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems, SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {buildArray} from 'shared/web';

export function SmsGateways() {
  const {data: konzultaConfigData, isLoading} = useSmsGetKonzultaCredentialsQuery();
  const [patchKonzultaConfig] = useSmsPatchKonzultaCredentialsMutation();

  const handleSwitchChange = (enabled: boolean) => {
    patchKonzultaConfig({
      body: {enabled},
    })
      .unwrap()
      .catch(handleApiError);
  };

  const items = buildArray<SettingsStackItemProps>([
    {
      cyId: testIds.settings.smsGatewaysKonzulta('link'),
      title: i18n.t('page.integrations.labels.smsGatewayKonzulta'),
      url: settingsRoutes.smsGatewaysKonzulta,
      switchProps: {
        name: 'sms-gateways-konzulta',
        value: konzultaConfigData?.enabled ?? false,
        onChange: handleSwitchChange,
      },
    },
  ]);

  return (
    <SettingsTemplate
      header={{title: i18n.t('page.integrations.labels.smsGateways')}}
      data-testid="integrations-smsGateways-settings"
    >
      <DataStatus data={konzultaConfigData} isLoading={isLoading}>
        {() => <SettingsStackItems items={items} />}
      </DataStatus>
    </SettingsTemplate>
  );
}
